export default __webpack_public_path__ + "static/media/3.39ba84ce.png";